/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Futaroku_BlurbInputs */

const ja_home_brands_futaroku_blurb = /** @type {(inputs: Home_Brands_Futaroku_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海外eスポーツチームの公式アパレルとギアを中心にアイテムをセレクトして販売する「FUTAROKU」。取り扱いブランドは全て正規取扱。`)
};

const en_home_brands_futaroku_blurb = /** @type {(inputs: Home_Brands_Futaroku_BlurbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online store, offline popup store, imported game products and original product development and production for game brands, esports teams and more.`)
};

/**
* | output |
* | --- |
* | "Online store, offline popup store, imported game products and original product development and production for game brands, esports teams and more." |
*
* @param {Home_Brands_Futaroku_BlurbInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_futaroku_blurb = /** @type {((inputs?: Home_Brands_Futaroku_BlurbInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Futaroku_BlurbInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_futaroku_blurb(inputs)
	return en_home_brands_futaroku_blurb(inputs)
});